<template>
<div>
  <div class="contact__info">
    <div class="first-col">
      <span class="fas fa-envelope"></span>
    </div>

    <div>
      <div>
      <p class="h3">{{ company.name }}</p>

      <p class="text-small">
        Ihr Immobilienmakler in {{ company.city }} und Umgebung.
      </p>

      <ul class="text-small list-unstyled">
        <li>
          <span>Adresse:</span>
          {{ company.street }}<br />
          <span></span> {{ company.zip }} {{ company.city }}
        </li>

        <li>
          <span>Telefon:</span>
          <a :href="'tel:' + company.phone">
              {{ company.phone }}
          </a>
        </li>

        <li>
          <span>E-Mail:</span>
          <a :href="'mailto:' + company.email">
            E-Mail senden</a>
        </li>
      </ul>
      </div>
    </div>
  </div>

  <div class="contact__info">
    <div class="first-col">
      <span class="fas fa-map-marker-alt"></span>
    </div>

    <div>
      <div>
        <p class="h3">Ihr Weg zu uns</p>

        <p class="text-small">
          Nehmen Sie mit uns Kontakt auf oder besuchen Sie uns direkt persönlich in unserem Ladenlokal. Wir freuen uns auf Sie.
        </p>

        <a :href="'https://www.google.de/maps?daddr=' + company.street + ', ' + company.zip + '+' + company.city + '&saddr='"
          title="Route jetzt berechnen"
          target="_blank"
          class="link--arrow">
            Route jetzt berechnen
        </a>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: "ContactCompanyInfo",

  computed: {
    company() {
      return this.$yeti.company();
    }
  },

  methods: {
    onMapLoad(o) {
      o.L.marker(o.defaultCenter).addTo(o.map);
      this.mapCenter = o.defaultCenter;
    }
  }
}
</script>
